import { SVGProps } from 'react';

const PDFIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g>
            <path
                d="M37.2279 74.4558C57.7873 74.4558 74.454 57.7891 74.454 37.2296C74.454 16.6702 57.7873 0.00344849 37.2279 0.00344849C16.6684 0.00344849 0.00170898 16.6702 0.00170898 37.2296C0.00170898 57.7891 16.6684 74.4558 37.2279 74.4558Z"
                fill="#FAFAFA"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.6081 63.6448C6.60905 66.9604 9.29998 69.6476 12.613 69.6456L49.0603 69.624L49.0491 30.8056L12.535 30.8273C9.25822 30.8292 6.59942 33.4911 6.60036 36.7675L6.6081 63.6448Z"
                fill="#E03E09"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.63006 35.0577C8.63077 37.5303 10.6382 39.5363 13.1105 39.5348L48.407 39.5139L48.4047 31.4468L12.2167 31.4683C10.2367 31.4695 8.62949 33.0779 8.63006 35.0577Z"
                fill="#A42E07"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.3883 4.80797L64.2228 15.6425V67.9193H13.5713V4.80797H53.3883Z"
                fill="white"
                stroke="#ABABAB"
                strokeWidth="0.348873"
                strokeMiterlimit="1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.3884 4.80834L64.2225 15.6429H53.3884V4.80834Z"
                fill="#ABABAB"
            />
            <rect
                x="17.4856"
                y="27.8571"
                width="42.8571"
                height="5.01429"
                rx="2.50714"
                fill="#E03E09"
                fillOpacity="0.65"
            />
            <rect
                x="17.4856"
                y="35.4214"
                width="42.8571"
                height="5.01429"
                rx="2.50714"
                fill="#E03E09"
                fillOpacity="0.4"
            />
            <rect x="17.4856" y="19.9928" width="32.1429" height="5.01429" rx="2.50714" fill="#E03E09" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.6317 47.0898C67.6317 42.9388 64.2618 39.5688 60.1101 39.5688H13.1785V69.6527H60.1101C64.2618 69.6527 67.6317 66.2828 67.6317 62.1318V47.0898Z"
                fill="#E03E09"
            />
            <path
                d="M24.3317 59.75V48.1136H28.9226C29.8052 48.1136 30.5571 48.2822 31.1783 48.6193C31.7995 48.9527 32.273 49.4167 32.5987 50.0114C32.9283 50.6023 33.093 51.2841 33.093 52.0568C33.093 52.8295 32.9264 53.5114 32.593 54.1023C32.2597 54.6932 31.7768 55.1534 31.1442 55.483C30.5154 55.8125 29.754 55.9773 28.8601 55.9773H25.9339V54.0057H28.4624C28.9358 54.0057 29.326 53.9242 29.6328 53.7614C29.9434 53.5947 30.1745 53.3655 30.326 53.0739C30.4813 52.7784 30.5589 52.4394 30.5589 52.0568C30.5589 51.6705 30.4813 51.3333 30.326 51.0455C30.1745 50.7538 29.9434 50.5284 29.6328 50.3693C29.3222 50.2064 28.9283 50.125 28.451 50.125H26.7919V59.75H24.3317ZM38.8161 59.75H34.6911V48.1136H38.8501C40.0206 48.1136 41.0282 48.3466 41.8729 48.8125C42.7176 49.2746 43.3672 49.9394 43.8217 50.8068C44.2801 51.6742 44.5092 52.7121 44.5092 53.9205C44.5092 55.1326 44.2801 56.1742 43.8217 57.0455C43.3672 57.9167 42.7138 58.5852 41.8615 59.0511C41.013 59.517 39.9979 59.75 38.8161 59.75ZM37.1513 57.642H38.7138C39.4411 57.642 40.0528 57.5133 40.549 57.2557C41.049 56.9943 41.424 56.5909 41.674 56.0455C41.9278 55.4962 42.0547 54.7879 42.0547 53.9205C42.0547 53.0606 41.9278 52.358 41.674 51.8125C41.424 51.267 41.0509 50.8655 40.5547 50.608C40.0585 50.3504 39.4467 50.2216 38.7195 50.2216H37.1513V57.642ZM46.3317 59.75V48.1136H54.0362V50.142H48.7919V52.9148H53.5249V54.9432H48.7919V59.75H46.3317Z"
                fill="white"
            />
        </g>
    </svg>
);

export default PDFIcon;
